module.exports = __webpack_public_path__ + "img/70.6f1ac2b4.svg";